/**
 * PHARMAKON - Alert Component  ·  ERP Design System v3
 * Alert/notification strip — renders the erp `.alert` classes (styles/global.css).
 */

import React, { ReactNode } from "react";
import { Icon } from "./primitives";

export type AlertVariant = "info" | "warn" | "danger" | "success";

export interface AlertProps {
  variant?: AlertVariant;
  children: ReactNode;
  icon?: ReactNode;
  onClose?: () => void;
  className?: string;
}

// variant → erp `.alert` tone class
const TONE: Record<AlertVariant, string> = {
  info: "info",
  warn: "warning",
  danger: "error",
  success: "success",
};

export const Alert: React.FC<AlertProps> = ({
  variant = "info",
  children,
  icon,
  onClose,
  className = "",
}) => {
  return (
    <div className={`alert ${TONE[variant]} ${className}`}>
      {icon && <span className="ai">{icon}</span>}
      <div className="flex-1">{children}</div>
      {onClose && (
        <button
          onClick={onClose}
          className="xbtn flex-shrink-0"
          aria-label="Fermer"
        >
          <Icon name="x" size={16} />
        </button>
      )}
    </div>
  );
};

export default Alert;
